export const CONSULT = {
  it: {
    hero: {
      label: "Contatti",
      l1: "Hai un progetto in mente?",
      l2: "Partiamo da una call conoscitiva gratuita.",
      sub: "Raccontami la tua azienda, il progetto che vuoi realizzare o il problema che stai cercando di risolvere. Prima del nostro confronto posso dare una prima occhiata alla tua azienda e al tuo sito, così da arrivare alla call con un primo quadro della situazione.",
    },
    left: {
      title: "Parliamo del tuo progetto",
      body: "Che tu stia cercando di strutturare il marketing, riposizionare il brand, organizzare una fiera, lanciare un prodotto o semplicemente capire da dove partire, possiamo iniziare da un confronto.",
      emailLabel: "Email",
      phoneLabel: "Telefono",
      linkedinLabel: "LinkedIn",
    },
    form: {
      overline: "Call conoscitiva gratuita",
      title: "Raccontami il tuo progetto. Prima capiamo il problema, poi valutiamo insieme cosa serve.",
      fullname: "Nome e Cognome *",
      phFullname: "Nome e Cognome",
      email: "Email *",
      phEmail: "nome@azienda.it",
      phone: "Numero di telefono *",
      phPhone: "+39 ...",
      company: "Azienda *",
      phCompany: "Nome della tua azienda",
      website: "Sito web aziendale",
      phWebsite: "https://www.tuaazienda.it",
      websiteNote: "Mi permette di avere una prima panoramica dell'attività prima della call.",
      interest: "Di cosa hai bisogno?",
      interestOptions: [
        { value: "essential", label: "Pacchetto Essential — Direzione" },
        { value: "growth", label: "Pacchetto Growth — Sviluppo" },
        { value: "premium", label: "Pacchetto Premium — Continuità" },
        { value: "fiera", label: "Fiera / Evento" },
        { value: "product-launch", label: "Product Launch" },
        { value: "checkup", label: "Check-up Marketing" },
        { value: "sito-essenziale", label: "Sito Essenziale" },
        { value: "servizio-specifico", label: "Un servizio specifico (logo, brochure, sito…)" },
        { value: "marketing-branding", label: "Marketing & Branding — altro" },
        { value: "non-so", label: "Non lo so ancora / Vorrei confrontarmi" },
      ],
      when: "Quando vorresti iniziare?",
      whenOptions: [
        { value: "subito", label: "Il prima possibile" },
        { value: "1-mese", label: "Entro 1 mese" },
        { value: "1-3-mesi", label: "1–3 mesi" },
        { value: "3-6-mesi", label: "3–6 mesi" },
        { value: "valutando", label: "Sto ancora valutando" },
      ],
      message: "Raccontami brevemente il progetto",
      phMessage: "Qual è il tuo obiettivo? Qual è il problema principale che vorresti risolvere?",
      budget: "Budget indicativo",
      budgetOptions: [
        { value: "lt-2500", label: "Meno di €2.500" },
        { value: "2500-5000", label: "€2.500–€5.000" },
        { value: "5000-10000", label: "€5.000–€10.000" },
        { value: "gt-10000", label: "Oltre €10.000" },
        { value: "non-definito", label: "Non ho ancora definito un budget" },
      ],
      budgetNote: "Il budget ci aiuta semplicemente a capire il perimetro del progetto e a valutare la soluzione più coerente.",
      privacyA: "Ho letto e accetto la",
      privacyLink: "Privacy Policy",
      privacyB: "e autorizzo il trattamento dei miei dati personali per essere ricontattato in merito alla mia richiesta.",
      submit: "Prenota la call conoscitiva",
      sending: "Invio in corso",
      microcopy: "Nessun impegno. La call conoscitiva gratuita di 20-30 minuti serve a capire il progetto, gli obiettivi e se posso realmente esserti utile.",
      errors: {
        required: "Campo obbligatorio",
        email: "Inserisci un'email valida",
        url: "Inserisci un URL valido (es. https://www.tuaazienda.it)",
        privacy: "Devi accettare la Privacy Policy per continuare",
        generic: "Qualcosa non ha funzionato. Riprova tra poco.",
      },
    },
    confirm: {
      title: "Richiesta ricevuta.",
      body: "Grazie per avermi raccontato il tuo progetto. Analizzerò le informazioni che mi hai lasciato e ti ricontatterò per fissare la call conoscitiva.",
      nextTitle: "Il prossimo passo è semplice:",
      steps: [
        "Ricevo la tua richiesta",
        "Guardo le informazioni e il sito che mi hai indicato",
        "Ci sentiamo per la call conoscitiva",
        "Se c'è un progetto concreto, definiamo insieme il percorso più adatto",
      ],
      cta: "Torna alla home",
    },
    how: {
      overline: "Come funziona",
      title: "Quattro passi per capire se posso esserti utile.",
      steps: [
        { n: "01", t: "Mi racconti il progetto", b: "Obiettivi, situazione attuale e problema da risolvere." },
        { n: "02", t: "Guardo la tua azienda", b: "Se lasci il sito web, posso arrivare alla call con una prima conoscenza della tua attività." },
        { n: "03", t: "Ci confrontiamo", b: "Call conoscitiva gratuita di 20-30 minuti per capire priorità, esigenze e possibile direzione." },
        { n: "04", t: "Definiamo il prossimo passo", b: "Se c'è un progetto concreto, valuteremo insieme la soluzione più adatta." },
      ],
    },
    homeCta: {
      overline: "Il prossimo passo",
      title: "Non sai da dove partire? Partiamo dal problema.",
      body: "Raccontami cosa stai cercando di ottenere, cosa hai già fatto e dove ti sei bloccato.",
      primary: "Raccontami il tuo problema",
      secondary: "Scopri tutti i servizi",
    },
    pay: {
      label: "Pagamento",
      l1: "Pagamento",
      l2: "sicuro.",
      sub: "Questa pagina è riservata ai clienti che hanno ricevuto il link direttamente da me. Inserisci importo e riferimento del progetto: il pagamento avviene in modo sicuro con carta.",
      name: "Nome e Cognome *",
      phName: "Nome e Cognome",
      email: "Email *",
      phEmail: "nome@azienda.it",
      amount: "Importo (€) *",
      phAmount: "Es. 2400",
      ref: "Riferimento / progetto *",
      phRef: "Es. Pacchetto Growth — acconto",
      submit: "Procedi al pagamento",
      sending: "Reindirizzamento al pagamento sicuro",
      secure: "Pagamento sicuro con carta. Nessun dato della carta passa da questo sito.",
      successTitle: "Pagamento completato.",
      successBody: "Grazie: la conferma arriverà via email. Per qualsiasi necessità puoi contattarmi direttamente.",
      cancelTitle: "Pagamento annullato.",
      cancelBody: "Nessun addebito è stato effettuato. Puoi riprovare quando vuoi.",
      back: "Torna alla home",
      errRequired: "Campo obbligatorio",
      errEmail: "Inserisci un'email valida",
      errAmount: "Inserisci un importo valido maggiore di zero",
      errGeneric: "Qualcosa non ha funzionato. Riprova tra poco.",
    },
  },
  en: {
    hero: {
      label: "Contact",
      l1: "Do you have a project in mind?",
      l2: "Let's start with a free introductory call.",
      sub: "Tell me about your company, the project you want to deliver or the problem you're trying to solve. Before our call I can take a first look at your company and your website, so we start with an initial picture of the situation.",
    },
    left: {
      title: "Let's talk about your project",
      body: "Whether you're trying to structure your marketing, reposition your brand, organise a fair, launch a product or simply understand where to start, we can begin with a conversation.",
      emailLabel: "Email",
      phoneLabel: "Phone",
      linkedinLabel: "LinkedIn",
    },
    form: {
      overline: "Free introductory call",
      title: "Tell me about your project. First we understand the problem, then we assess together what's needed.",
      fullname: "Full name *",
      phFullname: "Full name",
      email: "Email *",
      phEmail: "name@company.com",
      phone: "Phone number *",
      phPhone: "+39 ...",
      company: "Company *",
      phCompany: "Your company name",
      website: "Company website",
      phWebsite: "https://www.yourcompany.com",
      websiteNote: "It gives me a first overview of your business before the call.",
      interest: "What do you need?",
      interestOptions: [
        { value: "essential", label: "Essential package — Direction" },
        { value: "growth", label: "Growth package — Development" },
        { value: "premium", label: "Premium package — Continuity" },
        { value: "fiera", label: "Trade Fair / Event" },
        { value: "product-launch", label: "Product Launch" },
        { value: "checkup", label: "Marketing Check-up" },
        { value: "sito-essenziale", label: "Essential Website" },
        { value: "servizio-specifico", label: "A specific service (logo, brochure, website…)" },
        { value: "marketing-branding", label: "Marketing & Branding — other" },
        { value: "non-so", label: "Not sure yet / I'd like to discuss" },
      ],
      when: "When would you like to start?",
      whenOptions: [
        { value: "subito", label: "As soon as possible" },
        { value: "1-mese", label: "Within 1 month" },
        { value: "1-3-mesi", label: "1–3 months" },
        { value: "3-6-mesi", label: "3–6 months" },
        { value: "valutando", label: "I'm still evaluating" },
      ],
      message: "Briefly tell me about the project",
      phMessage: "What is your goal? What is the main problem you'd like to solve?",
      budget: "Indicative budget",
      budgetOptions: [
        { value: "lt-2500", label: "Less than €2,500" },
        { value: "2500-5000", label: "€2,500–€5,000" },
        { value: "5000-10000", label: "€5,000–€10,000" },
        { value: "gt-10000", label: "Over €10,000" },
        { value: "non-definito", label: "I haven't defined a budget yet" },
      ],
      budgetNote: "The budget simply helps us understand the scope of the project and assess the most coherent solution.",
      privacyA: "I have read and accept the",
      privacyLink: "Privacy Policy",
      privacyB: "and authorise the processing of my personal data to be contacted regarding my request.",
      submit: "Book the introductory call",
      sending: "Sending",
      microcopy: "No commitment. The free 20-30 minute introductory call is about understanding the project, the goals and whether I can genuinely be useful to you.",
      errors: {
        required: "Required field",
        email: "Please enter a valid email",
        url: "Please enter a valid URL (e.g. https://www.yourcompany.com)",
        privacy: "You must accept the Privacy Policy to continue",
        generic: "Something went wrong. Please try again shortly.",
      },
    },
    confirm: {
      title: "Request received.",
      body: "Thank you for telling me about your project. I'll review the information you shared and get back to you to schedule the introductory call.",
      nextTitle: "The next step is simple:",
      steps: [
        "I receive your request",
        "I review the information and the website you shared",
        "We talk in the introductory call",
        "If there's a concrete project, we define the right path together",
      ],
      cta: "Back to home",
    },
    how: {
      overline: "How it works",
      title: "Four steps to understand whether I can be useful to you.",
      steps: [
        { n: "01", t: "You tell me the project", b: "Goals, current situation and the problem to solve." },
        { n: "02", t: "I look at your company", b: "If you share your website, I come to the call with a first knowledge of your business." },
        { n: "03", t: "We talk", b: "A free 20-30 minute introductory call to understand priorities, needs and a possible direction." },
        { n: "04", t: "We define the next step", b: "If there's a concrete project, we'll assess the most suitable solution together." },
      ],
    },
    homeCta: {
      overline: "The next step",
      title: "Don't know where to start? Let's start from the problem.",
      body: "Tell me what you're trying to achieve, what you've already done and where you got stuck.",
      primary: "Tell me about your problem",
      secondary: "Discover all services",
    },
    pay: {
      label: "Payment",
      l1: "Secure",
      l2: "payment.",
      sub: "This page is reserved for clients who received the link directly from me. Enter the amount and the project reference: payment is handled securely by card.",
      name: "Full name *",
      phName: "Full name",
      email: "Email *",
      phEmail: "name@company.com",
      amount: "Amount (€) *",
      phAmount: "E.g. 2400",
      ref: "Reference / project *",
      phRef: "E.g. Growth package — deposit",
      submit: "Proceed to payment",
      sending: "Redirecting to secure checkout",
      secure: "Secure card payment. No card data passes through this site.",
      successTitle: "Payment completed.",
      successBody: "Thank you: confirmation will arrive by email. For anything else, you can contact me directly.",
      cancelTitle: "Payment cancelled.",
      cancelBody: "No charge was made. You can try again anytime.",
      back: "Back to home",
      errRequired: "Required field",
      errEmail: "Please enter a valid email",
      errAmount: "Please enter a valid amount greater than zero",
      errGeneric: "Something went wrong. Please try again shortly.",
    },
  },
};
